export const de = {
    translations: {
        values: {
            one: "Eins",
            two: "Zwei",
            three: "Drei",
            four: "Vier",
            five: "Fünf",
            six: "Sechs",
            seven: "Sieben",
            eight: "Acht",
            nine: "Neun",
            redFive: "rote Fünf",
            east: "Ostwind",
            south: "Südwind",
            west: "Westwind",
            north: "Nordwind",
            white: "weißer Drache",
            green: "grüner Drache",
            red: "roter Drache",
            hidden: "verdeckter Stein",
        },
        suits: {
            characters: "Schrift",
            circles: "Kreis",
            bamboo: "Bambus"
        },
        shuupai: "{{suit}}-{{value}}",
        winds: {
            east: "Osten",
            south: "Süden",
            west: "Westen",
            north: "Norden"
        },
        roundName: "{{wind}} {{number}}-{{repeats}}",
        trainer: {
            disclaimer: "Achtung: Dieser Trainer hilft zu lernen, die Effizienz der Hand im aktuellen Zug zu optimieren. Er berücksichtigt nicht die Effizienz zukünftiger Züge, ob es besser wäre, die Effizienz zu ignorieren, oder wie man den Wert der Hand maximiert. Dieser Trainer repräsentiert also nur für manche Hände die ideale Spielweise. Starke Spieler spielen nicht immer so, können es aber prinzipiell. Weiterführendes Lesen hilft dabei, derartige strategische Entscheidungen zu lernen. In den Einstellungen sind Optionen für gezielteres Training zu finden.",
            instructions: "Klicke den Stein an, den du abwerfen möchtest.",
            start: "Eine neue Hand wurde begonnen: {{hand}}",
            complete: "Deine Hand ist nun bereit. Glückwunsch! Deine Effizienz war {{achieved}}/{{total}}, bzw. {{percent}}%.",
            newHandButtonLabel: "Neue Hand",
            loadButtonLabel: "Hand eingeben",
            roundWind: "Rundenwind:",
            seatWind: "Platzwind:",
            doraIndicator: "Dora-Indikator:",
            copyHand: "Kopiere die Hand",
            copied: "Kopiert!",
            error: {
                load: "Fehler: Die eingegebene Hand konnte nicht erkannt werden",
                wallEmpty: "Fehler: Nicht genügend Steine übrig.",
                wallEmptyShuffle: "Nicht genügend Steine in der Mauer, um eine neue Hand zu erstellen. Mische."
            },
            playerNames: {
                you: "Du",
                right: "Shimocha",
                across: "Toimen",
                left: "Kamicha"
            }
        },
        history: {
            label: "Verlauf der Hand",
            tenhouLinkText: "[Akzeptierte Steine]",
            concise: {
                discard: "Abwurf: {{tile}}",
                acceptance: " ({{count}} Stein).",
                acceptance_plural: " ({{count}} Steine).",
                loweredShanten: " (Rückschritt in Shanten).",
                optimal: " Optimal:",
                optimalSpoiler: " {{tile}}",
                best: " Das war die beste Wahl!",
                exceptionalNoten: " Alle Steine, mit denen du gewinnen kannst sind in deiner Hand, also ist sie nicht bereit.",
                furiten: " Furiten.",
                furitenWarning: " Beachte mögliches zukünftiges Furiten.",
                exhausted: " Keine Steine mehr in der Mauer. Viel Glück beim nächsten Mal! ",
                draw: " Gezogen: {{tile}}. "
            },
            verbose: {
                discard: "Du hast {{tile}} abgeworfen, sodass",
                acceptance: " noch {{count}} Stein deine Hand verbessern kann.",
                acceptance_plural: " noch {{count}} Steine deine Hand verbessern können.",
                loweredShanten: " dein Shanten erhöht wurde - du bist jetzt weiter weg von einer bereiten Hand.",
                optimal: " Der effizienteste Stein zum Abwerfen",
                optimalSpoiler: ", die {{tile}}, ",
                best: " Das war die beste Wahl!",
                exceptionalNoten: " Deine Hand ist bereit, aber alle Steine, mit denen du gewinnen kannst, sind in deiner Hand. Sie zählt damit nicht als bereit in fast allen Regelwerken, also musst du deine Hand ändern.",
                furiten: " Du bist im Furiten. Du kannst diese Hand nicht durch Ron gewinnen, weil du einen Stein, mit dem du gewinnen würdest, abgeworfen hast.",
                furitenWarning: " Beachte mögliches zuküftiges Furiten. Einige Steine, die deine Hand verbessern würden, hast du abgeworfen.",
                exhausted: " Keine Steine mehr in der Mauer. Viel Glück beim nächsten Mal! ",
                draw: " Du hast {{tile}} gezogen. "
            }
        },
        discards: {
            label: "Abwürfe",
            discardCount: "Du hast {{count}} Stein abgeworfen.",
            discardCount_plural: "Du hast {{count}} Steine abgeworfen.",
            tilesLeft: "Es ist noch {{count}} Stein in der Mauer.",
            tilesLeft_plural: "Es sind noch {{count}} Steine in der Mauer."
        },
        settings: {
            buttonLabel: "Einstellungen",
            tilesAllowed: "Erlaubte Steine:",
            characters: "Schrift",
            circles: "Kreise",
            bamboo: "Bambus",
            honors: "Trumpf",
            sanma: "Drei Spieler Regeln",
            redFives: "Anzahl der roten Fünfen:",
            verbose: "Ausführliche Steinbenennungen (\"Bambus-Eins\" vs \"1s\")",
            showIndexes: "Steinindexe anzeigen",
            concise: "Verkürzter Verlauf",
            spoilers: "Zeige die beste Option",
            shuffle: "Die abgeworfenen Ziegel werden zu Beginn einer neuen Hand wieder untergemischt",
            simulate: "Simuliere Abwürfe anderer Spieler",
            exceptions: "Beachte außergwöhnliche Hände (Kokushi/Dreizehn Waisen und Chiitoitsu/Sieben Paare)",
            minShanten: "Minimale Shanten in der Starthand:",
            minShantenLimit: "(bis zur Anzahl der erlaubten Farben)",
            sort: "Sortiere die Hand",
            blind: "Verstecke Hand",
            useTimer: "Mit Zeitlimit",
            time: "Zeit pro Abwurf:",
            extraTime: "Zusätzliche Zeit pro Hand:",
            seconds: "Sekunden"
        },
        stats: {
            buttonLabel: "Statistik",
            info: "Diese Statistik wird jedes Mal aktualisiert, wenn du eine Hand abschließt.",
            ready: "Bereite Hände: {{count}} Hand",
            ready_plural: "Bereite Hände: {{count}} Hände",
            discards: "Steine abgeworfen: {{count}} Stein",
            discards_plural: "Steine abgeworfen: {{count}} Steine",
            average: "Durchschnittliche Abwürfe bis zur bereiten Hand: {{average}} Abwürfe",
            optimal: "Optimale Abwürfe: {{count}} Abwurf",
            optimal_plural: "Optimale Abwürfe: {{count}} Abwürfe",
            optimalRate: "Rate der optimalen Abwürfe: {{percent}}% ({{achieved}}/{{total}})",
            efficiency: "Erreichte Effizienz: {{count}} Stein",
            efficiency_plural: "Erreichte Effizienz: {{count}} Steine",
            possible: "Mögliche Effizienz: {{count}} Stein",
            possible_plural: "Mögliche Effizienz: {{count}} Steine",
            overall: "Relative Effizienz: {{percent}}% ({{achieved}}/{{total}})",
            reset: "Statistik zurücksetzen",
            confirmation: "Bist du sicher, dass du alle Statistiken zurücksetzen willst? Dies kann nicht rückgängig gemacht werden.",
            yes: "Ja, zurücksetzen!",
            no: "Nein, nicht zurücksetzen!"
        },
        credits: {
            label: "Credits",
            tilesPreLink: "Stein-Bilder kombiniert von ",
            tilesLinkText: "riichi-mahjong-tiles von FluffyStuff auf Github",
            tilesPostLink: ", lizensiert unter der ",
            ccLinkText: "Creative Commons Attribution 4.0 International License.",
            shantenPreLink: "Shanten Berechnung adaptiert von ",
            shantenLinkText: "diese C Programmsammlung.",
            shantenPostLink: "",
        },
        menu: {
            trainer: "Trainer",
            analyzer: "Spielanalyse",
            allLast: "Trainer für die letzte Runde",
            explorer: "Handanalyse",
            utils: "Verschiedenes",
            language: "Sprachen",
            defense: "Defensive"
        },
        allLast: {
            placements: {
                first: "Erster",
                second: "Zweiter",
                third: "Dritter",
                fourth: "Vierter"
            },
            title: "Trainer für die letzte Runde",
            maxFu: "Maximale Fu",
            showDifferences: "Zeige Punktedifferenzen",
            loadInstructions: "Gib Komma-getrennte Punktzahlen für Osten, Süden, Westen und Norden in dieser Reihenfolge ein, um eine Situation zu laden.",
            loadLabel: "Lade Situation",
            newLabel: "Neue zufällige Situation",
            info: "Du bist in der letzten Runde auf Platz vier. Die Punktzahlen sind die folgenden:",
            escapeHeader: "Vermeiden des vierten Platzes",
            riichiHeader: "Riichi Ansagen",
            higherHeader: "Höhere Platzierungen",
            question: "Mit welcher minimalen Punktzahl wirst du durch {{action}} {{placement}}?",
            riichiQuestion: "Wenn {{player}} Riichi ansagt, was ist dann die minimale Punktzahl, sodass du durch {{action}} {{placement}} wirst?",
            ron: "Ron gegen {{target}} ",
            tsumo: "Tsumo",
            han: "Han",
            fu: "Fu",
            submit: "Bestätigen",
            wrong: "Falsch! Mit dieser Punktzahl wirst du nicht {{placement}}! Es ergibt sich folgende Situation: ",
            tooMuch: "Mit dieser Punktzahl wirst du {{placement}}, aber es ist nicht die minimale. Es ergibt sich folgende Situation: ",
            correct: "Richtig! Das ist die niedrigste Punktzahl, um {{placement}} zu werden!",
            score: "{{han}} Han {{fu}} Fu",
            results: "Ergebnis:",
            you: "Du",
            error: {
                few: "Fehler: Nicht genügend Punktzahlen abgegeben.",
                NaN: "Fehler: Die Punktzahl für {{seat}} ist fehlerhaft."
            }
        },
        analyzer: {
            instructions1: "Anleitung:",
            instructions2: "Kopiere die URL deines Spiels in das Textfeld unten.",
            instructions3: 'Rechtsklicke den erscheinenden Link und wähle "Speichern als" oder "Speichere Link als".',
            instructions4: 'Wähle dann "Durchsuchen..." und lade die gespeicherte Datei hoch.',
            instructions5: "Falls du eine mjlog-Datei hast, kannst du diese alternativ mit der Endung .zip umbenennen.",
            instructions6: "Lade dann die Datei, die im Zip-Ordner enthalten ist, hoch.",
            instructions7: "Du kannst auch eine XML-Datei der Wiederholung des Spiels hochladen, falls du ein Programm hast, das diese erstellt.",
            instructions8: "Die Einschränkungen des Effizienztrainers gelten auch hier.",
            instructions9: "Bezüglich Sicherheitsbewertungen sind höhere Werte besser. 1 ist am schlechtesten, 15 am besten.",
            URLplaceholder: "URL der Wiederholung",
            invalidURL: "Fehlerhafte URL",
            downloadInstructions: "Rechtsklick diesen Link und wähle Speichern als!",
            roundSelect: "Wähle eine Runde",
            playerSelect: "Spieler ändern",
            previousTurn: "Vorheriger Zug",
            nextTurn: "Nächster Zug",
            nextIssue: "Nächster Fehler",
            turn: "{{round}}, Zug {{turn}}",
            discards: "Abgeworfene Steine: {{symbols}} ({{tiles}})",
            calls: "Gerufenes: {{calls}}",
            callsSeparator: ", ",
            tenhouLinkText: "[Tenhou Ukeire Analyse]",
            replayError: "Irgendwas ist schief gelaufen.",
            noName: "Unbekannt",
            startingHand: "Deine Starthand ist {{hand}}. Sie benötigt {{count}} Stein, um bereit zu sein. Der Dora-Indikator ist {{dora}}.",
            startingHand_plural: "Deine Starthand ist {{hand}}. Sie benötigt {{count}} Steine, um bereit zu sein. Der Dora-Indikator ist {{dora}}.",
            unknownAction: "Hey, hier ist etwas, dass ich nicht berücksichtige. Schicke mir die Aufzeichnung, damit ich es hinzufügen kann. {{debugInfo}}",
            call: "Du hast {{tile}} gerufen, um {{meld}} zu vervollständigen. ({{hand}})",
            callSameShanten: "Dieser Aufruf hat deine Shanten nicht verringert.",
            ryuukyoku: "Die Runde endete in einem Unentschieden.",
            playerRiichi: "Du hast Riichi ausgerufen. Beende Analyse.",
            otherRiichi: "Spieler {{number}} hat Riichi ausgerufen. ",
            fold: "Deine Hand ist noch {{shanten}} Shanten, deshalb solltest du sie aufgeben.",
            probablyFold: "Deine Hand ist noch einen Stein vom bereit sein entfernt. Du solltest Aufgeben in Betracht ziehen.",
            win: "Spieler {{number}} hat die Runde gewonnen.",
            kandora: "Der neue Dora-Indikator ist {{tile}}.",
            draw: "Du hast {{tile}} gezogen. ({{hand}})",
            chosenSafety: "Die Sicherheitswertung von {{tile}} ist {{rating}}. ({{- explanation}}) ",
            correctSafety: "Das war der sicherste Zug.",
            bestSafety: "Sicherster Stein: {{tile}}, mit einer Sicherheitswertung von {{rating}}. ({{- explanation}})",
            safetyExplanations: {
                zero: "Diese Nachricht solltest du nicht sehen. Malde dich, falls doch.",
                one: "nicht-Suji 4/5/6",
                two: "nicht-Suji 3/7",
                three: "nicht-Suji 2/8",
                four: "letzte Chance",
                five: "nicht-Suji 1/9",
                six: "Erster Trumpfstein",
                seven: "Suji 3/7",
                eight: "Suji 2/8",
                nine: "Suji 4/5/6",
                ten: "zweiter Trumpfziegel",
                eleven: "Erster Suji Randstein",
                twelve: "Zweiter Suji Randstein",
                thirteen: "Dritter Suji Randstein / dritter Trumpfziegel",
                fourteen: "Vierter Suji Randstein / vierter Trumpfziegel",
                fifteen: "genbutsu, 100% sicher"
            }
        },
        explorer: {
            warning: "Achtung: Das Laden einer Hand kann dazu führen, dass die Seite für 5-10 Sekunden einfriert, möglicherweise länger, wenn du einen älteren Computer hast, abhängig von der Komplexität der Hand. Nach dem Laden werden dir alle Ukeire und Verbesserungsmöglichkeiten für jede Abwurfoption angezeigt, selbst solche, die dein Shanten verschlechtern. Normalerweise werden Optionen, die strikt schlechter sind als andere nicht angezeigt, aber dies lässt sich durch die Schaltfläche unten verändern. Wenn du nur Informationen zu den Ukeire brauchst, sollte tenhou.net/2/ ausreichen.",
            shanten: "Shanten: Die minimale Anzahl der benötigten Steine, um die Hand bereit zu machen.",
            ukeire: "Ukeire: Die Anzahl der Steine, die deine Shanten verringern.",
            notableDiscards: "Zeige nur bessere Abwürfe",
            allDiscards: "Zeige alle möglichen Abwürfe",
            discardInfo: {
                discard: "Wirf {{tile}} ab:",
                shanten: "Shanten: {{count}}",
                ukeire: "Ukeire: {{count}} ({{tiles}})",
                expand: "Zeige die Ukeire beim nächsten Shanten",
                draw: "{{draw}} gezogen, {{discard}} abgeworfen: {{count}} Ukeire",
                average: "Durchscnitt: {{average}}",
                upgrades: "Steine, die die Ukeire verbessern: {{count}} ({{tiles}})",
                expandUpgrades: "Zeige Verbesserungen"
            }
        },
        defense: {
            instructions: "Wirf den sichersten Stein ab.",
            finalHands: "Resultierende Hände:",
            hand: "{{player}}: {{hand}}",
            safetyRatings: "Sicherheitswertungen",
            averagedSafetyRating: "Gegen mehrere Riichis werden die Sicherheitswertungen gemittelt und die höchste als beste gewertet.",
            safetyRating: "{{rating}}: {{- explanation}}",
            riichiCount: "Anzahl der Riichis: ",
            minTurns: "Minimale Anzahl der Züge bevor Riichi ausgerufen wurde: ",
            tilesInHand: "Anzahl der Steine in der Hand: "
        },
        utils: {
            convertHeader: "Hand Übersetzer",
            convertButtonLabel: "Hand übersetzen",
            ascii: "ASCII:",
            emoji: "Emoji:",
            stateHeader: "Zufallsgenerator für Spielsituationen",
            playerLabel: "{{seat}} Spieler {{you}}",
            points: "Punkte:",
            discards: "Abwürfe:",
            stateButtonLabel: "Neue Situation generieren",
            info: "Es ist Zug {{turn}} in {{round}}. Du bist im {{seat}}.",
            dora: "Der Dora-Indikator ist {{tile}}."
        }
    }
}